import { defineMessages } from "react-intl";

export const messages = defineMessages({
  noResultsText: {
    id: "bookingslist.noresults.text",
    defaultMessage: "No results",
    description: "Text to be shown when no results from bookings list",
  },
});
